export default __webpack_public_path__ + "static/media/download-app.6223d0f3.svg";